// How one saved quotation / prototype line reads on screen (not the customer print, which keeps
// the wording exactly as typed).
//
// A product-group line is stored as FREETEXT + productGroupId, so without this it read as
// "Free text" followed by whatever wording was typed - twenty lines could all say the same thing
// and hide which group each one stands for (user, 2026-09-19). The GROUP is the line's identity:
// it leads, and the customer wording sits under it only when it says something different.
const same = (a, b) => (a || "").trim().toLowerCase() === (b || "").trim().toLowerCase();

export const isGroupLine = (line) => line.lineType === "FREETEXT" && line.productGroupId != null && line.productGroupId !== "";

export const quotationLineTypeLabel = (line) =>
  isGroupLine(line) ? "Product group" : line.lineType === "FREETEXT" ? "Free text" : "Product";

const QuotationLineLabel = ({ line }) => {
  if (isGroupLine(line)) {
    const groupName = line.productGroupName || `Group ${line.productGroupId}`;
    return (
      <>
        <div>{groupName}</div>
        {line.description && !same(line.description, groupName) && (
          <div className="text-muted small">{line.description}</div>
        )}
      </>
    );
  }

  return (
    <>
      {line.description}
      {line.productCode ? <span className="text-muted"> ({line.productCode})</span> : ""}
    </>
  );
};

export default QuotationLineLabel;
